import { render, staticRenderFns } from "./Welcomes.vue?vue&type=template&id=618c8672"
import script from "./Welcomes.vue?vue&type=script&lang=js"
export * from "./Welcomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports